module.exports = __webpack_public_path__ + "img/about-bac-bottom.ae950d0c.png";